export default __webpack_public_path__ + "static/media/bbaDAI.0938b2b5.png";